import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { FormSection } from '~/features/sso-settings/FormSection';
import { isFieldValid } from '~/features/sso-settings/FormSection.utils';
import { FormSection as FormSectionType } from '~/types/SSOForm';

type Props = {
  clientId: string;
  sections: FormSectionType[];
  onHide: () => void;
  onSubmit: () => void;
  onDelete: () => void;
};

export const SAMLConfigEdit = ({
  clientId,
  sections,
  onHide,
  onSubmit,
  onDelete,
}: Props) => {
  const isFormValid = useMemo(() => {
    return sections.every((section) =>
      section.configs.every((formField) => isFieldValid(formField)),
    );
  }, [sections]);

  const intl = useIntl();

  return (
    <Modal
      isVisible={true}
      isFullPage={true}
      title={intl.formatMessage({
        id: 'SamlConfigEdit.title',
        defaultMessage: 'Edit SAML SSO',
        description: 'Title for SAML configuration edit modal',
      })}
      onCancel={onHide}
      onHide={onHide}
      primaryAction={{
        text: intl.formatMessage({
          id: 'SamlConfigEdit.submitButton',
          defaultMessage: 'Submit',
          description: 'Submit button text',
        }),
        onClick: onSubmit,
        disabled: !isFormValid,
      }}
      secondaryActions={[
        {
          text: intl.formatMessage({
            id: 'SamlConfigEdit.deleteButton',
            defaultMessage: 'Delete Configuration',
            description: 'Delete configuration button text',
          }),
          onClick: onDelete,
          variant: 'danger',
        },
      ]}
    >
      <Layout w="60%" direction="column" alignSelf="center">
        {sections.map((section, index) => (
          <Box mb={8} key={`${index}_saml_sso_section`}>
            <FormSection
              clientId={clientId}
              section={section}
              onExplain={undefined}
            />
          </Box>
        ))}
      </Layout>
    </Modal>
  );
};
